import CalendarLocale from '../../vc-calendar/src/locale/nl_NL'
import TimePickerLocale from '../../time-picker/locale/nl_NL'

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'Selecteer datum',
    rangePlaceholder: [
      'Begin datum', 'Eind datum',
    ],
    ...CalendarLocale,
  },
  timePickerLocale: {
    ...TimePickerLocale,
  },
}

// All settings at: https://github.com/ant-design/ant-design/issues/424

export default locale



// WEBPACK FOOTER //
// ./components/date-picker/locale/nl_NL.js